import React, { useEffect, useMemo, useRef, useState } from 'react';
import { format } from "date-fns"
import { fr } from "date-fns/locale"
import { useCalendrierProps } from "./calendrier";
import { TypeCalendrier } from './calendrier-interfaces';

const CalendrierEnteteDate = ({ date, isSelected }: { date: Date; isSelected: Boolean }) => {
  // const CalendrierEnteteDate = ({date}: { date: Date }) => {
  const { typeCalendrier } = useCalendrierProps()
  const [monthFormat, setMonthFormat] = useState("EEEE");
  const cellEnteteRef = useRef<any>(null);

  useEffect(() => {
    if (!cellEnteteRef || !cellEnteteRef?.current || !cellEnteteRef?.current.clientWidth) return;
    if (cellEnteteRef?.current.clientWidth <= 63)
      setMonthFormat("EEE");
  }, [cellEnteteRef])

  const renderJour = useMemo(() => (
    <div ref={cellEnteteRef} className={`entete jour ${isSelected && 'selected'}`}>
      <div className={"date-text"}>{format(date, monthFormat, { locale: fr })}</div>
      <div className={"date-nombre"}>{format(date, "dd", { locale: fr })}</div>
    </div>
  ), [date, monthFormat])

  const renderMois = useMemo(() => (
    <div className={`entete jour ${isSelected && 'selected'}`}>
      <div>{format(date, "MMMM", { locale: fr })}</div>
    </div>
  ), [date])

  return typeCalendrier === TypeCalendrier.Jours ? renderJour : renderMois
};

export default CalendrierEnteteDate;